import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.project.MetaData')
export class MetaData extends AbstractModel {

    @JsonProperty(String, 'address')
    address: string;

    @JsonProperty(DateConverter, 'createTime')
    createTime?: Date;
}
